import React from 'react';

export const NotificationIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='48'
            height='48'
            viewBox='0 0 48 48'
            fill='none'
        >
            <rect width='48' height='48' rx='8' />
            <path
                d='M41.25 5.25C41.0719 5.25 40.8891 5.28281 40.7062 5.35781L13.6875 16.2141H6C5.5875 16.2141 5.25 16.5609 5.25 16.9922V31.0078C5.25 31.4391 5.5875 31.7859 6 31.7859H10.7672C10.5937 32.3297 10.5 32.9062 10.5 33.4922C10.5 36.5812 13.0219 39.0937 16.125 39.0937C18.7219 39.0937 20.9109 37.3312 21.5578 34.95L40.7109 42.6469C40.8937 42.7172 41.0766 42.7547 41.2547 42.7547C42.0469 42.7547 42.7547 42.0891 42.7547 41.1984V6.80625C42.75 5.91562 42.0469 5.25 41.25 5.25ZM16.125 35.7328C14.8828 35.7328 13.875 34.7297 13.875 33.4922C13.875 32.9672 14.0578 32.4656 14.3906 32.0672L18.3703 33.6656C18.2766 34.8187 17.3062 35.7328 16.125 35.7328ZM39.375 38.4703L14.9437 28.6547L14.3391 28.4109H8.625V19.5891H14.3391L14.9437 19.3453L39.375 9.52969V38.4703Z'
                fill='#6257D2'
            />
        </svg>
    );
};
